'use client';

import { useEnv } from '@/env/client';
import { APIProvider, Map, AdvancedMarker } from '@vis.gl/react-google-maps';
import { useId } from 'react';
import { twMerge } from 'tailwind-merge';

import { navigate } from '@lamesarv-sdk/tools';

import { LocationCustomPin } from '@/components/LocationCustomPin';

const DEFAULT_LOCATION = { lat: 38.1145497, lng: -100.9423212 };
const DEFAULT_ZOOM = 4.8;

export interface ILocationCenter {
  title: string;
  lat: number;
  lng: number;
  url?: string;
}

interface ILocationMapProps {
  locations: ILocationCenter[];
  classes_marker?: string;
  classes_marker_base?: string;
  classes_marker_shadow?: string;
  classes_marker_icon?: string;
  classes_marker_icon_section?: string;
  classes_marker_title?: string;
}

export const LocationMap = ({
  classes_marker,
  classes_marker_base,
  classes_marker_shadow,
  classes_marker_icon,
  classes_marker_icon_section,
  classes_marker_title,
  locations,
}: ILocationMapProps) => {
  const { env } = useEnv();
  const id = useId();

  return (
    <div className="advanced-marker-example w-full h-full">
      <APIProvider apiKey={env.GOOGLE_MAPS_API_KEY}>
        <Map mapId={id} defaultCenter={DEFAULT_LOCATION} defaultZoom={DEFAULT_ZOOM}>
          {locations.map((location) => (
            <AdvancedMarker
              key={location.title}
              position={{ lat: location.lat, lng: location.lng }}
              title={location.title}
              className={twMerge('real-estate-marker', classes_marker)}
              clickable
              onClick={() => navigate(location.url || '#')}
            >
              <LocationCustomPin
                title={location.title}
                classes_marker={classes_marker}
                classes_marker_base={classes_marker_base}
                classes_marker_shadow={classes_marker_shadow}
                classes_marker_icon={classes_marker_icon}
                classes_marker_icon_section={classes_marker_icon_section}
                classes_marker_title={classes_marker_title}
              />
            </AdvancedMarker>
          ))}
        </Map>
      </APIProvider>
    </div>
  );
};
